import {InfoView} from '@fantasmagames/slot/src/modules/hud/info/InfoView';
import Spine = PIXI.spine.Spine;
import {RecodeInfoView} from '@fantasmagames/slot/src/modules/hud/info/recode/RecodeInfoView';

export class GameInfoView extends RecodeInfoView {
	public translate(): void {
		if (!this._betText) {
			return;
		}

		const betText: string = this.translator.getObject('BaseStrings', 'generic', 'g_bet');
		this._betText.text = betText.toUpperCase();

		const winText: string = this.translator.getObject('BaseStrings', 'wins', 'g_total_win');
		this._winText.text = winText.toUpperCase();

		const balanceText: string = this.translator.getObject('BaseStrings', 'generic', 'g_balance');
		this._balanceText.text = balanceText.toUpperCase();
	}
}



// WEBPACK FOOTER //
// ./src/info/GameInfoView.ts